module.exports = "/assets/dist/img/balfour-celebratingu-white@2x.png?865689e9a545880f19c3b3cb520bd242";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/letter-jackets/site-footer/assets/balfour-celebratingu-white@2x.png
// module id = 1952
// module chunks = 30